module.exports = __webpack_public_path__ + "img/11-min.e7fdabfe.jpg";